import type { MeUserFragment } from 'api/core/generated';
import { AppSearchParams } from 'app-constants';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  initializeGoogleAnalytics,
  loadZendeskWidget,
  useSift,
} from 'services';
import { identifyUserInPostHog } from 'services/posthog-service';

import { useGoogleAnalytics } from './analytics/useGoogleAnalytics';
import { useRudderStack } from './use-rudderstack';

export const useInitializeAppServices = (user: Nullable<MeUserFragment>) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const productIdentifier =
    searchParams.get(AppSearchParams.referenceKey) ||
    searchParams.get(AppSearchParams.creditAccountHash) ||
    searchParams.get(AppSearchParams.creditLineWithdrawalHash) ||
    searchParams.get(AppSearchParams.creditLimitRecalculationHash);

  const { initialize: initializeRudderstack, trackPage } = useRudderStack();
  const { initializeSift, identifyUserInSift } = useSift();

  useGoogleAnalytics();

  useEffect(() => {
    loadZendeskWidget();
    initializeGoogleAnalytics();
    initializeSift();
    initializeRudderstack();
  }, []);

  useEffect(() => {
    identifyUserInSift(user?.id || null);
    identifyUserInPostHog({ user, hashIdentifier: productIdentifier });
  }, [user, productIdentifier]);

  useEffect(() => {
    trackPage(pathname);
  }, [pathname, trackPage]);
};
